import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="w-full bg-cream-100 py-14 sm:py-20" data-id="element-354" data-mp="cn7riumnqbzc">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-355" data-mp="7po2czof8esm">
        <SectionHeading title={<>
              📦 What’s inside{' '}
              <em className="not-italic text-gold-600" data-id="element-357" data-mp="3g5hi3caxhm8m">Occlusion 360™?</em>
            </>} subtitle="A complete visual system to help you stop relying on a mark and start analyzing the case as a whole." data-id="element-356" data-mp="7q7icauigt40" />

        <div className="mt-9 space-y-4 sm:space-y-5" data-id="element-358" data-mp="3l4aut2ie597q">
          {volumes.map(volume => <article key={volume.volume} className="overflow-hidden rounded-3xl border border-navy-900/10 bg-white shadow-card" data-id="element-359" data-mp="2xeqe6q9pmo1m">
              <div className="flex items-center gap-3 bg-navy-900 px-4 py-3 sm:px-6" data-id="element-360" data-mp="2sfdgtbl7pyks">
                <span className="rounded-full bg-gold-500 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.12em] text-navy-900" data-id="element-361" data-mp="29ez5g1hdyq2v">
                  {volume.volume}
                </span>
              </div>

              <div className="p-5 sm:p-6" data-id="element-362" data-mp="2j7en0xortcn8">
                <h3 className="font-display text-[21px] font-bold leading-tight text-navy-900 sm:text-2xl" data-id="element-363" data-mp="2o4wltv92qbhi">
                  {volume.title}
                </h3>
                <p className="mt-3 text-[15px] font-semibold leading-snug text-gold-700" data-id="element-364" data-mp="1qizaqix0x8fl">
                  {volume.lead}
                </p>
                <p className="mt-2.5 text-[14.5px] leading-relaxed text-navy-700/85" data-id="element-365" data-mp="20ekheud1ewvo">
                  {volume.body}
                </p>

                <p className="mt-5 text-[12px] font-bold uppercase tracking-[0.12em] text-navy-700/60" data-id="element-366" data-mp="24hqlbvcogbyz">
                  {volume.listLabel}
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-367" data-mp="3fut14o6ycxi3">
                  {volume.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-368" data-mp="1gphur03b509x">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-navy-900/5 text-navy-800" aria-hidden="true" data-id="element-369" data-mp="1bs9b0v2igo6k">
                        <CheckIcon className="h-3 w-3" data-id="element-370" data-mp="1ktpkn0li4m9q" />
                      </span>
                      <span className="text-[14px] leading-snug text-navy-800/90" data-id="element-371" data-mp="x3vaiqskhbt6">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-9 w-full max-w-md" data-id="element-372" data-mp="1226isx37re9a">
          <CTAButton label="I want Occlusion 360™" subline="Instant access · One-time payment · No monthly fees" data-id="element-373" data-mp="120lqle4dg7el" />
        </div>
      </div>
    </section>;
}